import {createFetchActions} from '../../services/createActions'
import {get, post} from '../../services/createAPICall'
import {getPMSBaseUrl, getConfigBaseUrl} from '../../services/apiService'

export const GET_ETL_STATUS = createFetchActions('GET_ETL_STATUS')
export const GET_PORTFOLIO_DOCS_INCLUDED = createFetchActions('GET_PORTFOLIO_DOCS_INCLUDED')
export const GET_PORTFOLIO_DOCS_ALL = createFetchActions('GET_PORTFOLIO_DOCS_ALL')
export const UPLOAD_PORTFOLIO_DOCS = createFetchActions('UPLOAD_PORTFOLIO_DOCS')
export const SAVE_INCLUDED_DOCS = createFetchActions('SAVE_INCLUDED_DOCS')
export const GET_PORTFOLIO_UPDATE_DATETIME = createFetchActions('GET_PORTFOLIO_UPDATE_DATETIME')
export const UPLOAD_RESTRICTED_PORTFOLIO = createFetchActions('UPLOAD_RESTRICTED_PORTFOLIO')
export const GET_RESTRICTED_PORTFOLIO = createFetchActions('GET_RESTRICTED_PORTFOLIO')

export const SET_INCLUDED_IDS = 'SET_INCLUDED_IDS'
export const CLEAR_PORTFOLIO_MANAGER_STATE = 'CLEAR_PORTFOLIO_MANAGER_STATE'
export const RESET_INCLUDED_DOCS = 'RESET_INCLUDED_DOCS'
export const SET_PROCESSED_PORTFOLIO_OBJECT = 'SET_PROCESSED_PORTFOLIO_OBJECT'
export const RESET_PROCESSED_PORTFOLIO_OBJECT = 'RESET_PROCESSED_PORTFOLIO_OBJECT'
export const SET_PORTFOLIO_DOCUMENT_DETAILS = 'SET_PORTFOLIO_DOCUMENT_DETAILS'
export const SET_PORTFOLIO_DOCUMENT_STATUS = 'SET_PORTFOLIO_DOCUMENT_DETAILS'
export const PF_UPLOAD_ONGOING = 'PF_UPLOAD_ONGOING'

export const getEtlStatus = (tenantId: string) => (dispatch: any) => {
	return dispatch(get(GET_ETL_STATUS, `${getConfigBaseUrl()}/v1/etl?tenantId=${tenantId}&etlType=portfolio`))
}

export const getPortfolioDocsIncluded =
	(page: number, size = 10) =>
	(dispatch: any) => {
		return dispatch(get(GET_PORTFOLIO_DOCS_INCLUDED, `${getPMSBaseUrl()}/v1/portfolios/documents/consolidate`))
	}

export const getPortfolioDocsAll =
	(page: number, size = 10, days: number) =>
	(dispatch: any) => {
		return dispatch(get(GET_PORTFOLIO_DOCS_ALL, `${getPMSBaseUrl()}/v1/portfolios/documents/today?days=${days}`))
	}

export const saveIncludedDocs = (ids: string[]) => (dispatch: any) => {
	return dispatch(post(SAVE_INCLUDED_DOCS, `${getPMSBaseUrl()}/v1/portfolios/documents/consolidate`, ids))
}

export const uploadPortfolioDocs = (data: any) => (dispatch: any) => {
	const headers = {
		'Content-Type': 'multipart/form-data',
	}
	return dispatch(post(UPLOAD_PORTFOLIO_DOCS, `${getPMSBaseUrl()}/v1/portfolios/documents/upload`, data, headers))
}

export const uploadPortfolioDocsCheck = (data: any) => (dispatch: any) => {
	const headers = {
		'Content-Type': data.headers !== 'json' ? 'multipart/form-data' : 'application/json',
	}
	return dispatch(post(UPLOAD_PORTFOLIO_DOCS, `${getPMSBaseUrl()}/etl`, data.data, headers))
}

export const uploadRestrictedPortfolio = (data: any) => (dispatch: any) => {
	const headers = {
		'Content-Type': 'multipart/form-data',
	}
	return dispatch(
		post(UPLOAD_RESTRICTED_PORTFOLIO, `${getPMSBaseUrl()}/v1/security/restricted-documents/upload`, data, headers)
	)
}

export const getRestrictedPortfolioDetails = () => (dispatch: any) => {
	return dispatch(get(GET_RESTRICTED_PORTFOLIO, `${getPMSBaseUrl()}/v1/security/restricted-documents/today`))
}

export const getPortfolioUpdateDateTime = () => (dispatch: any) => {
	return dispatch(get(GET_PORTFOLIO_UPDATE_DATETIME, `${getPMSBaseUrl()}/v1/portfolios?page=0&size=1`))
}

export const clearPortfolioManagerState = () => {
	return {
		type: CLEAR_PORTFOLIO_MANAGER_STATE,
	}
}

export const setProcessedPortfolioObject = (data: any) => {
	return {
		type: SET_PROCESSED_PORTFOLIO_OBJECT,
		payload: {
			data: data,
		},
	}
}

export const resetProcessedPortfolioObject = () => {
	return {
		type: RESET_PROCESSED_PORTFOLIO_OBJECT,
	}
}

export const setPortfolioDocumentStatus = (id: string, status: string) => {
	return {
		type: SET_PORTFOLIO_DOCUMENT_STATUS,
		payload: {
			id: id,
			status: status,
		},
	}
}

export const pfUploadOngoing = (uploading: boolean) => {
	return {
		type: PF_UPLOAD_ONGOING,
		payload: {
			uploading,
		},
	}
}
